import React, { useEffect } from 'react';
import {
	CardContainer,
	CircularImageWrapper,
	CircularImage,
	NumberCircle,
	DescriptionContainer,
	TitleText,
	DescriptionText,
	DescriptionText2,
	Connector,
	Title,
	Content,
	ContentWrapper,
	Card,
	CardInner,
	ImageSection,
	ContentSection,
	ImageWrapper,
	CardImage,
	CardWrapper,
	ModuleCard,
	ModuleHeader,
	ModuleHeaderContent,
	ModuleNumber,
	ModuleIcon,
	ModuleTitle,
	ModuleSubtitle,
	ModuleSubtitle2,
	ModuleBody,
	ModuleImage,
	ModuleOverlay,
	ModuleFooter,
	ModuleFooterLink,
} from './APVendorDBModule.styles';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const APVendorDBModule = ({
	number,
	title,
	subtitle,
	imagePath,
	modulePath,
}) => {
	const history = useHistory();

	// useEffect(() => {
	// 	const c = document.getElementById('apvendordbmodule');
	// 	const ctx = c.getContext('2d');

	// 	if (window.innerWidth <= 1440) {
	// 		ctx.beginPath();
	// 		ctx.moveTo(6, 6);
	// 		ctx.lineTo(20, 20);
	// 		ctx.lineTo(40, 20);
	// 		ctx.strokeStyle = '#393939';
	// 		ctx.lineWidth = 2;
	// 		ctx.stroke();

	// 		ctx.beginPath();
	// 		ctx.arc(6, 6, 5, 0, 2 * Math.PI);
	// 		ctx.fillStyle = '#393939';
	// 		ctx.fill();
	// 	} else if (window.innerWidth <= 1920 && window.innerWidth > 1440) {
	// 		ctx.beginPath();
	// 		ctx.moveTo(6, 44);
	// 		ctx.lineTo(25, 25);
	// 		ctx.lineTo(60, 25);
	// 		ctx.strokeStyle = '#393939';
	// 		ctx.lineWidth = 2;
	// 		ctx.stroke();

	// 		ctx.beginPath();
	// 		ctx.arc(6, 44, 5, 0, 2 * Math.PI);
	// 		ctx.fillStyle = '#393939';
	// 		ctx.fill();
	// 	}
	// }, []);

	const loadModule = path => {
		history.push(path);
	};

	return (
		// <CardContainer>
		// 	<CircularImageWrapper onClick={() => loadModule(modulePath)}>
		// 		<CircularImage className="moduleImage">
		// 			<img src={imagePath} alt="benchmark" />
		// 		</CircularImage>
		// 		<NumberCircle>{number}</NumberCircle>
		// 	</CircularImageWrapper>
		// 	{/* <Connector>
		// 		<canvas id="apvendordbmodule" width="100" height="50" />
		// 	</Connector> */}
		// 	<DescriptionContainer>
		// 		<TitleText>{title}</TitleText>
		// 		<DescriptionText>How does spend stack up</DescriptionText>
		// 		<DescriptionText2>against industry peers?</DescriptionText2>
		// 	</DescriptionContainer>
		// </CardContainer>
		// <CardWrapper onClick={() => loadModule(modulePath)}>
		// 	{number && <NumberCircle>{number}</NumberCircle>}
		// 	<CardContainer>
		// 		<ImageWrapper>
		// 			<CardImage>
		// 				<img src={imagePath} alt={title} />
		// 			</CardImage>
		// 		</ImageWrapper>
		// 		<ContentSection>
		// 			<TitleText>{title}</TitleText>
		// 			<DescriptionText>{subtitle}</DescriptionText>
		// 		</ContentSection>
		// 	</CardContainer>
		// </CardWrapper>

		<ModuleCard>
			<ModuleHeader>
				<ModuleIcon>
					<span className="icon-analysis" />
				</ModuleIcon>
				<ModuleHeaderContent>
					<ModuleTitle>{title}</ModuleTitle>
					<ModuleSubtitle>How to conduct category</ModuleSubtitle>
					<ModuleSubtitle2>specific analysis?</ModuleSubtitle2>
				</ModuleHeaderContent>
				<ModuleNumber>4</ModuleNumber>
			</ModuleHeader>
			<ModuleBody>
				<ModuleImage src={imagePath} alt={title} />
				<ModuleOverlay />
			</ModuleBody>
			<ModuleFooter>
				<ModuleFooterLink onClick={() => loadModule(modulePath)}>
					View Details{' '}
					<svg
						width="16"
						height="16"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13 6L18 12L13 18"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M6 12H18"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</ModuleFooterLink>
			</ModuleFooter>
		</ModuleCard>
	);
};

export default APVendorDBModule;
